app.controller('CommonPersonController', ['$rootScope', '$scope', '$bootstrapModal', function ($rootScope, $scope, $bootstrapModal) {

    $scope.selected_address_id = null;
    $scope.postcode_lookup_unavailable = false;
    $scope.postcode_search_error = null;

    $scope.regex_person = new RegExp(/^[\w . -]*$/);
    $scope.regex_warning_text = 'Sorry commas and non-alphanumeric characters are not allowed. Only use letters, numbers, dashes "-", underscores "_" or periods "."'

    function passRegexValue(value) {
        return value ? value.split(/[^0-9A-Za-z _-]/).join("") : "";
    }

    if (!$scope.getPerson) {
        $scope.getPerson = function () {
            return {}
        }
    }

    if (!$scope.fromPersons) {
        $scope.fromPersons = function () {
            const userData = $rootScope.model.account.user_data;
            return userData ? $rootScope.site_helper.requireObject(userData.addresses) : {}
        }
    }

    if (!$scope.fromCountries) {
        $scope.fromCountries = function () {
            const customerData = $rootScope.model.account.customer_data;
            return customerData ? $rootScope.site_helper.requireObject(customerData.countries) : {}
        }
    }

    $scope.onPersonChange = function (callbacks) {
        const person = $scope.getPerson();
        const fromPersons = $scope.fromPersons();
        const fromPerson = $scope.selected_address_id && fromPersons[$scope.selected_address_id] ? fromPersons[$scope.selected_address_id] : {};

        $rootScope.site_helper.resetObject(person);

        for (let key in fromPerson) {
            const value = fromPerson[key] ? fromPerson[key] : "";
            if (key === "name" || key === "address1" || key === "address2") {
                setPersonValue(key, passRegexValue(value), person)
            } else {
                setPersonValue(key, value, person)
            }
        }

        handleCallbacks(callbacks);
    }

    $scope.onCountryChange = function (callbacks) {
        onPostcodeCountryChange(callbacks);
    }

    $scope.onPostcodeChange = function (callbacks) {
        onPostcodeCountryChange(callbacks);
    }

    $scope.postcodeText = function () {
        const countryCode = $scope.getPerson().country;
        if (countryCode === "GB") {
            return "Postcode"
        }
        if (countryCode === "IE") {
            return "Eircode"
        }
        return "Postcode/Eircode"
    }


    function onPostcodeCountryChange(callbacks) {
        const person = $scope.getPerson();
        setPersonValue("town", "", person)
        setPersonValue("county", "", person)
        handleCallbacks(callbacks);
    }

    function setPersonValue(key, value, person) {
        if ($scope.validPersonKeys && !$scope.validPersonKeys.includes(key)) {
            return;
        }
        person[key] = value;
    }

    function handleCallbacks(callbacks) {
        if (!callbacks) {
            return;
        }
        callbacks = $scope.site_helper.isArray(callbacks) ? callbacks : [callbacks];
        for (let i = 0; i < callbacks.length; i++) {
            callbacks[i]();
        }
    }

    $scope.postcodeLookup = function (callbacks) {
        const postcode = $scope.getPerson().postcode;
        $scope.postcode_lookup_error = null;

        if (postcode) {
            $rootScope.service.account.postcodeLookup(postcode, function (success, addresses) {

                if (success) {
                    $scope.postcode_lookup_unavailable = false;

                    const items = {
                        selected_address: null,
                        addresses: addresses
                    }
                    items.callback = function () {
                        const selectedAddress = items.selected_address;

                        const person = $scope.getPerson();
                        const countryID = selectedAddress.country ? selectedAddress.country.toUpperCase() : null;
                        if (countryID && $scope.fromCountries()[countryID]) {
                            setPersonValue("country", countryID, person);
                        }


                        setPersonValue("address1", passRegexValue(selectedAddress.address1), person);
                        setPersonValue("address2", passRegexValue(selectedAddress.address2.split(/[^0-9A-Za-z _-]/).join("")), person);
                        setPersonValue("town", selectedAddress.town ? selectedAddress.town : "", person);
                        setPersonValue("county", selectedAddress.county ? selectedAddress.county : "", person);
                        setPersonValue("postcode", selectedAddress.postcode ? selectedAddress.postcode : person.postcode, person);

                        handleCallbacks(callbacks);
                    }

                    $bootstrapModal.open({
                        templateUrl: 'CommonModalPostcodeLookup.html',
                        controller: 'CommonModalSimpleController',
                        //size: 'md',
                        resolve: {
                            items: items
                        }
                    });

                } else {
                    testPostcodeLookup(function () {
                        if (!$scope.postcode_lookup_unavailable) {
                            $scope.postcode_lookup_error = "Sorry we did not find your postcode, please check and try again.";
                        } else {
                            $scope.postcode_lookup_error = "Postcode look up error.";
                        }
                    });
                }
            });

        } else {
            $scope.postcode_lookup_error = "Please add a valid Postcode.";
        }
    };

    function testPostcodeLookup(callback) {

        const testPostcode = "BT80 9LU";
        $rootScope.service.account.postcodeLookup(testPostcode, function (success) {
            $scope.postcode_lookup_unavailable = !success;
            if (callback) {
                callback()
            }
        });
    }
}]);